import React from 'react';
import FeaturedBanner from './FeaturedBanner';
import FeaturedSubjects from './FeaturedSubjects';
import CoursesSection from './CoursesSection';
import ChallengesSection from './ChallengesSection';
import AIProductsSection from './AIProductsSection';
import TestimonialsSection from './TestimonialsSection';
import CollaboratorsSection from './CollaboratorsSection';
import '../../assets/styles/MainContent.css';

const MainContent = ({ challengesData = {}, productsData = [], isLoading = false }) => {
  if (isLoading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>;
  }

  return (
    <div className="main-content">
      <FeaturedBanner />
      <FeaturedSubjects />
      <CoursesSection />
      <ChallengesSection challengesData={challengesData} />
      <AIProductsSection productsData={productsData} />
      <TestimonialsSection />
      <CollaboratorsSection />
    </div>
  );
};

MainContent.defaultProps = {
  challengesData: { Technology: [] },
  productsData: [],
  isLoading: false,
};

export default MainContent;